import { render, staticRenderFns } from "./InvoiceManageCrud.vue?vue&type=template&id=0f8ede8e&"
import script from "./InvoiceManageCrud.vue?vue&type=script&lang=js&"
export * from "./InvoiceManageCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports